import { useContext } from "react";
import { Context } from "../index";

export const useSocket = () => {
    const { socket } = useContext(Context);
    return socket.socketRef;
};
